<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
    title="パケットフィルタリング設定情報"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container fluid>
            <v-row class="mb-3">
              <v-col cols="6">
                <v-row v-if="clickRowVnConItem">
                  <v-col cols="12">
                    <app-label-group
                      label="VNコネクト名"
                      :value="
                        clickRowVnConItem.vnConnectName +
                        '(' +
                        clickRowVnConItem.wnumber +
                        ')'
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-if="clickRowCloudVnConItem">
                  <v-col cols="12">
                    <app-label-group label="VNコネクト名">
                      <template #value>
                        <div class="ml-3">
                          {{ clickRowCloudVnConItem.vnConnectNameAct }}({{
                            clickRowCloudVnConItem.wnumberAct
                          }})
                          <div v-if="clickRowCloudVnConItem.wnumberSby">
                            {{ clickRowCloudVnConItem.vnConnectNameSby }}({{
                              clickRowCloudVnConItem.wnumberSby
                            }})
                          </div>
                        </div>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <v-row v-if="clickRowSaseGatewayItem">
                  <v-col cols="12">
                    <app-label-group label="VNコネクト名">
                      <template #value>
                        <div class="ml-3">
                          {{ clickRowSaseGatewayItem.vnConnectNameAct }}({{
                            clickRowSaseGatewayItem.wnumberAct
                          }})
                          <div>
                            {{ clickRowSaseGatewayItem.vnConnectNameSby }}({{
                              clickRowSaseGatewayItem.wnumberSby
                            }})
                          </div>
                        </div>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <v-row v-if="clickRowAcLineItem">
                  <v-col cols="5">
                    <app-label-group
                      label="回線番号(E番号)"
                      :value="clickRowAcLineItem.enumber"
                    />
                  </v-col>
                  <v-col cols="5">
                    <app-label-group
                      label="メニュー"
                      :value="
                        $filter.enumTo(
                          clickRowAcLineItem.menu,
                          'acLinePktFilterMenu'
                        )
                      "
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="d-flex flex-row ga-2 justify-end">
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="
                    clickRowVnConItem
                      ? modifyVnConPackets()
                      : clickRowAcLineItem
                        ? modifyAcLinePackets()
                        : clickRowSaseGatewayItem
                          ? modifySaseGatewayPktRules()
                          : modifyCloudPktRules()
                  "
                  >設定</v-btn
                >
                <v-btn v-if="downloadUrl" :href="downloadUrl" color="primary"
                  >一覧ダウンロード</v-btn
                >
              </v-col>
            </v-row>
            <app-table
              primary-key="packetFilterRuleSeq"
              :fields="packetFields"
              :items="packetFilteringItem"
              :fixed="true"
              :td-class="cellClass"
              :tr-class="() => undefined"
            >
              <template #cell(protocol)="data">
                <template v-if="data.item.protocol">
                  {{ $filter.enumTo(data.item.protocol, "protocol") }}
                </template>
                <template v-else>
                  {{ $filter.emptyTo(data.item.protocolNumber, "-") }}
                </template>
              </template>
              <template #cell(action)="data">
                {{ $filter.enumTo(data.item.action, "action") }}
              </template>
              <template #cell(srcAddress)="data">
                {{ $filter.emptyTo(data.item.srcAddress, "any") }}
              </template>
              <template #cell(srcPort)="data">
                {{ $filter.emptyTo(data.item.srcPort, "any") }}
              </template>
              <template #cell(dstAddress)="data">
                {{ $filter.emptyTo(data.item.dstAddress, "any") }}
              </template>
              <template #cell(dstPort)="data">
                {{ $filter.emptyTo(data.item.dstPort, "any") }}
              </template>
              <template #cell(description)="data">
                {{ $filter.emptyTo(data.item.description, "-") }}
              </template>
              <template #cell(filteringStatus)="data">
                {{
                  $filter.enumTo(data.item.filteringStatus, "filteringStatus")
                }}
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  AcLinePktFilterEntity,
  PacketFilterEntity,
  VnConnectPktFilterEntity,
  CloudPktFilterEntity,
  SaseGatewayPktFilterEntity,
} from "@/apis/PacketFilteringApi";
import { VueFinalModal } from "vue-final-modal";
import type { AppTableHeader } from "@/components/AppTable.vue";
import PacketFilteringEdit from "@/modals/packetFiltering/PacketFilteringEdit.vue";

export default defineComponent({
  name: "PacketFilteringReference",
  props: {
    /** パケットフィルタリング設定情報 */
    packetFilteringItem: {
      type: Array as PropType<PacketFilterEntity[]>,
      required: true,
    },
    /** 選択行のVNコネクト情報 */
    clickRowVnConItem: {
      type: Object as PropType<VnConnectPktFilterEntity>,
      required: false,
    },
    /** 選択行のアクセス回線情報 */
    clickRowAcLineItem: {
      type: Object as PropType<AcLinePktFilterEntity>,
      required: false,
    },
    /** 選択行クラウドVNコネクト情報 */
    clickRowCloudVnConItem: {
      type: Object as PropType<CloudPktFilterEntity>,
      required: false,
    },
    /** 選択行SASEゲートウェイVNコネクト情報 */
    clickRowSaseGatewayItem: {
      type: Object as PropType<SaseGatewayPktFilterEntity>,
      required: false,
    },
    packetFilterKeyId: {
      type: String,
      required: true,
    },
    /** クラウド向けパケットフィルタリング設定情報一覧ダウンロードURL */
    downloadUrl: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      packetFields: [
        {
          key: "protocol",
          title: "プロトコル",
          width: "170px",
        },
        {
          key: "action",
          title: "アクション",
          width: "170px",
        },
        {
          key: "srcAddress",
          title: "送信元アドレス",
          width: "200px",
        },
        {
          key: "srcPort",
          title: "送信元ポート",
          width: "200px",
        },
        {
          key: "dstAddress",
          title: "宛先アドレス",
          width: "200px",
        },
        {
          key: "dstPort",
          title: "宛先ポート",
          width: "200px",
        },
        {
          key: "filteringStatus",
          title: "フィルタリング有効/無効",
          width: "280px",
        },
        {
          key: "description",
          title: "備考",
          width: "300px",
        },
      ] as AppTableHeader<PacketFilterEntity>[],
    };
  },
  methods: {
    /** パケットフィルタ設定(VNコネクト)を表示 */
    async modifyVnConPackets() {
      await this.$modal.show(PacketFilteringEdit, {
        packets: this.packetFilteringItem,
        wnumberAct: this.clickRowVnConItem!.wnumber,
        vnConnectNameAct: this.clickRowVnConItem!.vnConnectName,
        menu: this.clickRowVnConItem!.menu,
        vnConnectPacketFilterKeyId: this.packetFilterKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** パケットフィルタ設定(アクセス回線)を表示 */
    async modifyAcLinePackets() {
      await this.$modal.show(PacketFilteringEdit, {
        packets: this.packetFilteringItem,
        enumber: this.clickRowAcLineItem!.enumber,
        menu: this.clickRowAcLineItem!.menu,
        accessLinePacketFilterKeyId: this.packetFilterKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** クラウド向けパケットフィルタ設定を表示 */
    async modifyCloudPktRules() {
      await this.$modal.show(PacketFilteringEdit, {
        packets: this.packetFilteringItem,
        wnumberAct: this.clickRowCloudVnConItem!.wnumberAct,
        vnConnectNameAct: this.clickRowCloudVnConItem!.vnConnectNameAct,
        wnumberSby: this.clickRowCloudVnConItem!.wnumberSby,
        vnConnectNameSby: this.clickRowCloudVnConItem!.vnConnectNameSby,
        menu: "MULTI_CLOUD_GW",
        vnConnectPacketFilterKeyId: this.packetFilterKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** SASEゲートウェイ向けパケットフィルタ設定を表示 */
    async modifySaseGatewayPktRules() {
      await this.$modal.show(PacketFilteringEdit, {
        packets: this.packetFilteringItem,
        wnumberAct: this.clickRowSaseGatewayItem!.wnumberAct,
        vnConnectNameAct: this.clickRowSaseGatewayItem!.vnConnectNameAct,
        wnumberSby: this.clickRowSaseGatewayItem!.wnumberSby,
        vnConnectNameSby: this.clickRowSaseGatewayItem!.vnConnectNameSby,
        menu: "SASE_GATEWAY",
        saseGatewayPacketFilterKeyId: this.packetFilterKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** tdにクラスをつける */
    cellClass(field: AppTableHeader<PacketFilterEntity>): string[] | undefined {
      if (field.key === "description") {
        return ["text-pre-wrap"];
      }
      return undefined;
    },
  },
});
</script>
